import { render, staticRenderFns } from "./BlockTag.vue?vue&type=template&id=19e6529e&scoped=true&"
import script from "./BlockTag.vue?vue&type=script&lang=ts&"
export * from "./BlockTag.vue?vue&type=script&lang=ts&"
import style0 from "./BlockTag.vue?vue&type=style&index=0&id=19e6529e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e6529e",
  null
  
)

export default component.exports